export class eventsData {
  id: number = 0
  title: string = ''
  text: string = ''
  imgUrl: string = ''
  startDate: string = ''
  endDate: string = ''
}
